
import SettingsForm from "../components/SettingsForm";
export function AdminShowConfSystem() {
    document.title = `Системни настройки`;

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Системни настройки</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Преглед системни настройки</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            <SettingsForm />
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminShowConfSystem;